import React, { Fragment } from "react";
import PropTypes from "prop-types";
import SafeHTML from "../SafeHTML";
import CustomPropTypes from "../../utils/customPropTypes";
import ButtonLink from "../ButtonLink";
import scrollToElement from "scroll-to-element";
// import style from "../../../scss/components/GenericBanner/Banner";
import ImageBlock from "../ImageBlock";
import hl_logo from "../../../img/hl_logo.png";
import SimpleSlider from "./slider";
import slider from "../../../scss/components/GenericBanner/slider";
import ArrowImage from "../../../img/arrowHL.svg";

export default class GenericBanner extends React.Component {
  static ControlTypes = {
    IntroHeroFood: "banner banner-hero banner-center banner-hero-sm food",
    IntroHeroProduct: "banner banner-hero banner-center banner-hero-sm product",
    IntroHero: "banner banner-hero banner-center banner-hero-sm",
    LeftAlignedHero: "banner banner-left banner-hero banner-mobile-stacked",
    CenteredAlignedCard: "banner banner-center banner-card hide-desc-mobile",
    LeftAlignedCard: "banner banner-left banner-card hide-desc-mobile",
    LeftAlignedPrefooter: "banner banner-left banner-sm banner-pre-footer",
    CenteredPrefooter: "banner banner-center banner-sm banner-pre-footer",
    RightAlignedHero: "banner banner-right banner-hero hide-desc-mobile",
    HeroGridCard: "banner banner-left banner-hero-grid",
    Error: "error",
  };
  static propTypes = {
    image: CustomPropTypes.Image,
    mobileImage: CustomPropTypes.Image,
    eyebrow: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string,
    video: PropTypes.object,
    button: PropTypes.object,
    link: PropTypes.object,
    controlType: PropTypes.string,
    showJumpLink: PropTypes.bool,
    showBackLink: PropTypes.bool,
    image1: CustomPropTypes.Image,
    mobileImage1: CustomPropTypes.Image,
    alt1: PropTypes.string,
    url1: PropTypes.string,
    image2: CustomPropTypes.Image,
    mobileImage2: CustomPropTypes.Image,
    alt2: PropTypes.string,
    url2: PropTypes.string,
    image3: CustomPropTypes.Image,
    mobileImage3: CustomPropTypes.Image,
    alt3: PropTypes.string,
    url3: PropTypes.string,
    image4: CustomPropTypes.Image,
    mobileImage4: CustomPropTypes.Image,
    alt4: PropTypes.string,
    url4: PropTypes.string,
    image5: CustomPropTypes.Image,
    mobileImage5: CustomPropTypes.Image,
    alt5: PropTypes.string,
    url5: PropTypes.string,
  };
  constructor(props) {
    super(props);
    (this.mobile = window.matchMedia("(max-width: 1025px)")),
      (this.desktop = window.matchMedia("(min-width: 1026px)"));
    this.state = {
      isMobile: false,
      activeTab: "tab0",
      isTabView: false,
      isMenuOpen: false,
    };
    if (this.mobile.matches) this.state.isMobile = true;
    if (this.desktop.matches) this.state.isMobile = false;
  }

  whatInTheBox = {};

  tabParts = this.props.description.replace(/(<([^>]+)>)/gi, "").split(",");

  componentDidMount() {

    console.log('seethis', this.props)

    let isColorFlexL2 = window.location.pathname.includes("colorflex-l2");
    let isBenchTop = window.location.pathname.includes("benchtop-spectrophotometers");
    let isProducts = window.location.pathname.includes("/products/");

    if (isColorFlexL2 || isBenchTop || isProducts) {
      this.setState({ isColorFlexL2Page: isColorFlexL2 });
      import("../../../scss/components/GenericBanner/BannerNew");
    } else {
      import("../../../scss/components/GenericBanner/Banner");
    }

    var tabview = window.matchMedia("(max-width: 1049px)");
    this.setState({ isTabView: tabview.matches });
    this.tabFunction;
    this._isMounted = true;
    this.mobile.addListener((e) => {
      if (e.matches && this._isMounted) {
        this.setState({ isMobile: true });
      }
    });
    this.desktop.addListener((e) => {
      if (e.matches && this._isMounted) this.setState({ isMobile: false });
    });

    var footerEl = document.getElementById("Connect Footer");
    var footerInnerEl = document.getElementById("banner-inner-id");
    // if (this.props.eyebrow === "Connect Footer") {
    //   footerEl.style.marginRight = 0;
    //   Object.assign(footerInnerEl.style, {
    //     position: "absolute",
    //     top: 0,
    //     right: 0,
    //     backgroundColor: "blue",
    //     height: "465px",
    //     display: "grid",
    //     placeItems: "center",
    //   });
    // }
    setTimeout(() => {
      if (this.props.eyebrow === "Products Info Banner") {
        document.getElementById("down-icon").style.display = "none";
        document.getElementById("banner-eyebrow").style.display = "none";
        document.getElementById(`${this.props.eyebrow}`).style.justifyContent =
          "end";
        document.getElementById("banner-inner-id").style.color = "black";
      }
    }, 0);
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  getBannerImageProp = () => {
    var img = {};
    if (this.state.isMobile && this.props.mobileImage) {
      img.url = this.props.mobileImage.url;
    } else if (this.props.image) {
      img.url = this.props.image.url;
    }
    img.title = this.props.eyebrow;
    return img;
  };
  getBannerImageText = () => {
    var imgData = [];
    for (let i = 1; i <= 5; i++) {
      const propName = `imgText${i}`;
      if (this.props[propName] !== undefined) {
        imgData.push(this.props[propName]);
      }
    }    
    return imgData;
  };
  getBannerImageDesc = () => {
    var imgDesc = [];
    for (let i = 1; i <= 5; i++){
      const propDesc = `imgDesc${i}`;
      if (this.props[propDesc] !== undefined){
        imgDesc.push(this.props[propDesc]);
      }
    }
    return imgDesc
  };
  getBannerButtonText = () => {
    var buttonText = [];
    for (let i = 1; i <= 5; i++){
      const propButton = `buttonText${i}`;
      if (this.props[propButton] !== undefined){
        buttonText.push(this.props[propButton])
      }
    }
    return buttonText
  };
  getSliderurls = () => {
    var sliderData = [];
    for (let i = 1; i <= 5; i++) {
      let tempObj = {};
      if (eval(`this.props.image${i}`)) {
        if (this.state.isMobile && eval(`this.props.mobileImage${i}`)) {
          tempObj.url = eval(`this.props.mobileImage${i}.url`);
        } else {
          tempObj.url = eval(`this.props.image${i}.url`);
        }
      }
      if (eval(`this.props.alt${i}`)) {
        tempObj.alt = eval(`this.props.alt${i}`);
      }
      if (eval(`this.props.url${i}`)) {
        tempObj.href = eval(`this.props.url${i}`);
      }
      if (Object.keys(tempObj).length !== 0) {
        sliderData.push(tempObj);
      }
    }
    return sliderData;
  };

  onButtonClick = (e) => {
    e.preventDefault();
    let el = document.querySelector(".main > section:nth-of-type(2)");
    scrollToElement(el);
  };
  getClassname = (suffix = "") => {
    let cls = this.props.controlType + `${suffix}`;
    if (this.props.className) {
      cls = cls + ` ${this.props.className}${suffix}`;
    }
    if (this.props.video) cls = cls + " has-video";
    return cls;
  };
  getGoToParentLink = () => {
    if (this.props.showBackLink) {
      var parentPage = document
        .querySelector("body")
        .getAttribute("parent-page");
      if (parentPage) {
        var [url, title] = parentPage.split(";");
        return (
          <div className="has-back-link">
            <div className="container">
              <a
                href={url}
                className="zindexback btn btn-link-normal btn-back-link"
              >
                <i className="icon icon-prev"></i>&nbsp;{title}
              </a>
            </div>
          </div>
        );
      }
    }
    return null;
  };

  openTab = (tabId) => {
    this.toggleMenu()
    // Hide all tab content
    if (this.state.activeTab !== tabId) {
      this.setState({ activeTab: tabId });
    }
  };

  navigateToContact = () => {
    var regexen = /\/en\//;
    var regexenuk = /\/en-uk\//;
    var regexblog = /\/blog\//;
    var regexes = /\/es\//;

    var url = window.location.pathname;

    if (regexenuk.test(url)) {
      window.location.href = "/en-uk/contact/#newContactFormId";
      return;
    }

    if (regexen.test(url)) {
      window.location.href = "/en/contact/#newContactFormId";
      return;
    }

    if (regexblog.test(url)) {
      window.location.href = "/en/contact/#newContactFormId";
      return;
    }

    if (regexes.test(url)) {
      window.location.href = "/es/contact/#newContactFormId";
      return;
    }
  };

  toggleMenu() {
    this.setState((prevState) => ({
      isMenuOpen: !prevState.isMenuOpen,
    }));
  }

  // Helper method to get the current language prefix from the path
  getCurrentLanguage() {
    const pathParts = window.location.pathname.split("/");
    return pathParts[1] || "en"; // Default to 'en' if no prefix exists
  }

  // Helper method to determine the base URL based on the environment
  getBaseUrl() {
    const hostname = window.location.hostname;

    if (hostname === "www.hunterlab.com") return "https://www.hunterlab.com";
    if (hostname === "staging.hunterlab.com") return "https://staging.hunterlab.com";
    if (hostname === "dev.hunterlab.com") return "https://dev.hunterlab.com";

    return ""; // Fallback for local or unknown environments
  }

  // Helper method to generate relative links
  generateLink(path) {
    const currentLang = this.getCurrentLanguage();
    const baseUrl = this.getBaseUrl();
    return `${baseUrl}/${currentLang}${path}`;
  }

  render() {
    const whatInTheBoxTab = this.whatInTheBox;
    const { activeTab, isMenuOpen } = this.state;
    return (
      <>
        <div>
          {this.props.title == "Contact Us" && (
            <section className="banner banner-hero-contact banner-center banner-hero-sm ">
              <div className="contact-banner">
                <div className="banner-object">
                  <ImageBlock
                    image={this.getBannerImageProp()}
                    imgClassName="object-embed"
                    addWrapper={false}
                    addImageAsBg={true}
                  ></ImageBlock>
                </div>
                <div className="banner-container-new">
                  <div
                    id={this.props.eyebrow}
                    className="container banner-wrapper-contact"
                  >
                    <div className="banner-inner-contact">
                      {this.props.eyebrow && (
                        <h5 className="hunterlab-title banner-title text-align-center">
                          {this.props.eyebrow}
                        </h5>
                      )}
                      {this.props.title && (
                        <h1 className="banner-main-title">
                          {this.props.title}
                        </h1>
                      )}
                      {this.props.header && <h2>{this.props.header}</h2>}
                      {this.props.description && (
                        <div className="banner-desc text-align-center">
                          <SafeHTML>{this.props.description}</SafeHTML>
                        </div>
                      )}
                    </div>
                    <div class="ui card top">
                      <div class="content">
                        <div class="description">
                          {" "}
                          <span class="">
                            <p data-block-key="yw99m">
                              We have a support portal that has the answers to
                              your most common support questions!{" "}
                              <a
                                href="https://support.hunterlab.com/hc/en-us"
                                target="_blank"
                              >
                                <b>Check it out here.</b>
                              </a>
                            </p>
                            <p data-block-key="nawmk">
                              If you don’t find what you need, please{" "}
                              <a
                                href="https://support.hunterlab.com/hc/en-us/requests/new"
                                target="_blank"
                              >
                                <b>submit</b>
                              </a>{" "}
                              a support request through our help center or email
                              us at{" "}
                              <a href="mailto:support@hunterlab.com">
                                support@hunterlab.com
                              </a>
                            </p>
                          </span>
                          <a
                            class="col ButtonLink btn btn-outline-contact supportBtn_contact"
                            href="https://support.hunterlab.com/hc/en-us/requests/new"
                            target="blank"
                          >
                            <span>Click Here for Support & Accessories</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {this.props.title == "Contáctenos" && (
            <section className="banner banner-hero-contact banner-center banner-hero-sm ">
              <div className="contact-banner">
                <div className="banner-object">
                  <ImageBlock
                    image={this.getBannerImageProp()}
                    imgClassName="object-embed"
                    addWrapper={false}
                    addImageAsBg={true}
                  ></ImageBlock>
                </div>
                <div className="banner-container-new">
                  <div
                    id={this.props.eyebrow}
                    className="container banner-wrapper-contact"
                  >
                    <div className="banner-inner-contact">
                      {this.props.eyebrow && (
                        <h5 className="hunterlab-title banner-title">
                          {this.props.eyebrow}
                        </h5>
                      )}
                      {this.props.title && (
                        <h1 className="banner-main-title">
                          {this.props.title}
                        </h1>
                      )}
                      {this.props.header && <h2>{this.props.header}</h2>}
                      {this.props.description && (
                        <div className="banner-desc">
                          <SafeHTML>{this.props.description}</SafeHTML>
                        </div>
                      )}
                    </div>
                    <div class="ui card top">
                      <div class="content">
                        <div class="description">
                          {" "}
                          <span class="">
                            <p data-block-key="yw99m">
                              We have a support portal that has the answers to
                              your most common support questions!{" "}
                              <a
                                href="https://support.hunterlab.com/hc/en-us"
                                target="_blank"
                              >
                                <b>Check it out here.</b>
                              </a>
                            </p>
                            <p data-block-key="nawmk">
                              If you don’t find what you need, please{" "}
                              <a
                                href="https://support.hunterlab.com/hc/en-us/requests/new"
                                target="_blank"
                              >
                                <b>submit</b>
                              </a>{" "}
                              a support request through our help center or email
                              us at{" "}
                              <a href="mailto:support@hunterlab.com">
                                support@hunterlab.com
                              </a>
                            </p>
                          </span>
                          <a
                            class="col ButtonLink btn btn-outline-contact supportBtn"
                            href="https://support.hunterlab.com/hc/en-us/requests/new"
                            target="blank"
                          >
                            <span className="cntfrmbtn">Click Here for Support & Accessories</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {this.props.title !== "Contact Us" &&
            this.props.title !== "Contáctenos" &&
            this.props.eyebrow !== "Product Category Banner" &&
            this.props.eyebrow !== "Products Info Banner" &&
            this.props.eyebrow !== "Connect Product Footer" &&
            this.props.eyebrow !== "whats_in_the_box_section" &&
            this.props.eyebrow !== "product_detail_youtube_banner" && (
              <section className={this.getClassname()}>
                <div>
                  {this.props.image && (
                    <div className="banner-object">
                      <ImageBlock
                        image={this.getBannerImageProp()}
                        imgClassName="object-embed"
                        addWrapper={false}
                        addImageAsBg={true}
                      ></ImageBlock>
                    </div>
                  )}
                  {this.props.video && (
                    <div className="banner-object">
                      <video
                        width="100%"
                        height="100%"
                        className="object-embed desktop-show"
                        playsInline
                        autoPlay
                        muted
                        loop
                      >
                        <source src={this.props.video.url} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                      <div className="logo-container-new mobile-show">
                        <img src={hl_logo} className="hl-logo-new" />
                      </div>
                      <video
                        width="100%"
                        height="100%"
                        className="object-embed mobile-show"
                        playsInline
                        autoPlay
                        muted
                        loop
                      >
                        <source
                          src="https://hunterlab-staging.s3.amazonaws.com/media/documents/Mobile_Video_HL.mp4"
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  )}
                  {this.props.image1 && (
                    <div className="banner-object slider">
                      <SimpleSlider
                        sliderData={this.getSliderurls()}
                        imgData={this.getBannerImageText()}
                        imgDesc={this.getBannerImageDesc()}
                        buttonText={this.getBannerButtonText()}
                      ></SimpleSlider>
                    </div>
                  )}
                  {this.getGoToParentLink()}
                  {this.props.image1 && (
                    <div className="banner-container-new-slider">
                      <div
                        id={this.props.eyebrow}
                        className="container banner-wrapper"
                      >
                        {this.props.children}
                      </div>
                    </div>
                  )}
                  {!this.props.image1 && (
                    <div className="banner-container-new">
                      <div
                        id={this.props.eyebrow}
                        className="container banner-wrapper"
                      >
                        {!this.props.image1 && (
                          <div id="banner-inner-id" className="banner-inner">
                            {this.props.eyebrow && (
                              <h5
                                className="hunterlab-title banner-title"
                                id="banner-eyebrow"
                              >
                                {this.props.eyebrow}
                              </h5>
                            )}
                            {this.props.title && (
                              <h1 className="banner-main-title">
                                {this.props.title}
                              </h1>
                            )}
                            {this.props.header && <h2>{this.props.header}</h2>}
                            {this.props.description && (
                              <div className="banner-desc">
                                <SafeHTML>{this.props.description}</SafeHTML>
                              </div>
                            )}
                            {this.props.button && this.props.button.text && (
                              <ButtonLink
                                className="btn banner-btn"
                                {...this.props.button}
                              />
                            )}

                            {this.props.link && this.props.link.text && (
                              <ButtonLink
                                className="btn btn-link banner-btn"
                                {...this.props.link}
                              />
                            )}
                            {this.props.showJumpLink && (
                              <a
                                href="#"
                                id="down-icon"
                                className="btn btn-circle btn-scrollToBottom"
                                onClick={this.onButtonClick}
                              >
                                <i className="icon icon-down"></i>
                              </a>
                            )}
                          </div>
                        )}
                        {this.props.children}
                      </div>
                    </div>
                  )}
                </div>
              </section>
            )}

          {this.props.title !== "Contact Us" &&
            this.props.title !== "Contáctenos" &&
            this.props.eyebrow === "Products Info Banner" && (
              <div>
                <section className={this.getClassname() + " product-home-banner-background"} style={this.state.isMobile ? { backgroundImage: "url('" + this.props.mobileImage.url + "')", backgroundSize: 'cover', marginTop: '94px', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', minHeight: '336px' } : { backgroundImage: "url('" + this.props.image.url + "')", backgroundSize: 'cover', marginTop: '7%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                  <div>
                    {/* {this.state.isMobile && (
                    <div className="banner-object">
                      <ImageBlock
                        height={true}
                        image={this.getBannerImageProp()}
                        imgClassName="product-home-banner prod-home-banner"
                        addWrapper={false}
                        addImageAsBg={false}
                      ></ImageBlock>
                    </div>
                  )} */}
                    {this.props.video && (
                      <div className="banner-object">
                        <video
                          width="100%"
                          height="100%"
                          className="object-embed desktop-show"
                          playsInline
                          autoPlay
                          muted
                          loop
                        >
                          <source src={this.props.video.url} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                        <div className="logo-container-new mobile-show">
                          <img src={hl_logo} className="hl-logo-new" />
                        </div>
                        <video
                          width="100%"
                          height="100%"
                          className="object-embed mobile-show"
                          playsInline
                          autoPlay
                          muted
                          loop
                        >
                          <source
                            src="https://hunterlab-staging.s3.amazonaws.com/media/documents/Mobile_Video_HL.mp4"
                            type="video/mp4"
                          />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                    )}
                    {this.props.image1 && (
                      <div className="banner-object slider">
                        <SimpleSlider
                          sliderData={this.getSliderurls()}
                        ></SimpleSlider>
                      </div>
                    )}
                    {this.getGoToParentLink()}
                    {this.props.image1 && (
                      <div className="banner-container-new-slider">
                        <div
                          id={this.props.eyebrow}
                          className="container banner-wrapper"
                        >
                          {this.props.children}
                        </div>
                      </div>
                    )}
                    {!this.props.image1 && (
                      <div className="banner-container-new">
                        <div
                          id={this.props.eyebrow}
                          className="container banner-wrapper"
                        >
                          {!this.props.image1 && (
                            <div
                              id="banner-inner-id"
                              className="banner-inner product-homepage-banner"
                              style={this.state.isMobile ? undefined : { marginBlockStart: '10px !important' }}>
                              {this.props.eyebrow && (
                                <h5
                                  className="hunterlab-title banner-title"
                                  id="banner-eyebrow"
                                >
                                  {this.props.eyebrow}
                                </h5>
                              )}
                              {this.props.title && (
                                <h1 className="banner-main-title">
                                  {this.props.title}
                                </h1>
                              )}
                              {this.props.header && (
                                <h1 className="product-header-homepage" style={this.state.isMobile ? { marginBlockEnd: '0', marginBottom: '2px !important' } : undefined}>
                                  {this.props.header}
                                </h1>
                              )}
                              {this.props.description && (
                                <div className="banner-desc product-home-banner-desc">
                                  <SafeHTML>{this.props.description}</SafeHTML>
                                  <div class="product-btns" style={this.state.isMobile ? { paddingRight: '40px', paddingTop: '0px' } : { paddingRight: '40px', paddingTop: '15px' }}><a href={this.generateLink("/contact/")}><button class="btn btn-outline-contact buy-now-btn" style={{ fontSize: '16px' }}>Schedule Demo</button></a>
                                  </div>
                                </div>
                              )}
                              {this.props.button && this.props.button.text && (
                                <ButtonLink
                                  className="btn banner-btn"
                                  {...this.props.button}
                                />
                              )}

                              {this.props.link && this.props.link.text && (
                                <ButtonLink
                                  className="btn btn-link banner-btn"
                                  {...this.props.link}
                                />
                              )}
                              {this.props.showJumpLink && (
                                <a
                                  href="#"
                                  id="down-icon"
                                  className="btn btn-circle btn-scrollToBottom"
                                  onClick={this.onButtonClick}
                                >
                                  <i className="icon icon-down"></i>
                                </a>
                              )}

                            </div>
                          )}
                          {this.props.children}
                        </div>
                      </div>
                    )}
                  </div>
                </section>
              </div>
            )}

          {this.props.title !== "Contact Us" &&
            this.props.title !== "Contáctenos" &&
            this.props.eyebrow.includes(["Connect Product Footer"]) && (
              <div>
                <div
                  className="product-home-prefooter-page"
                  style={{ backgroundImage: `url(${this.props?.image?.url})` }}
                >
                  {(this.state.isMobile || this.state.isTabView) && (
                    <div className="banner-object">
                      <ImageBlock
                        height={true}
                        image={this.getBannerImageProp()}
                        imgClassName="product-home-banner"
                        addWrapper={false}
                        addImageAsBg={true}
                      ></ImageBlock>
                    </div>
                  )}
                  <div className="product-detail-prefooter-data-outer">
                    <div className="product-detail-prefooter-data">
                      <p className="prefooter-right-banner-text">
                        <SafeHTML>{this.props?.description}</SafeHTML>
                      </p>
                      <a className="contact-btn" href={this.props?.button?.url}>
                        {this.props?.button?.text}
                      </a>
                    </div>
                    {/* <div class="product-btns" style={{paddingRight:'40px'}}><a href="https://dev.hunterlab.com/en/contact/"><button class="btn btn-outline-contact buy-now-btn" style={{fontSize:'16px'}}>Schedule Demo</button></a>
                      </div> */}
                  </div>
                </div>

                <div className="mobile-footer-content">
                  {this.props.description && (
                    <SafeHTML>{this.props.description}</SafeHTML>
                  )}
                  <a href={this.props?.button?.url} className="contact-btn">
                    {this.props?.button?.text}
                  </a>
                </div>
              </div>
            )}

          {this.props.title !== "Contact Us" &&
            this.props.title !== "Contáctenos" &&
            this.props.eyebrow === "Product Category Banner" && (
              // <div className="banner-container-new-category">
              //   <div
              //     id="Product Category Banner"
              //     className="container-category banner-wrapper-category"
              //   >
              //     <div className="img-cover-category">
              //       <ImageBlock
              //         image={this.getBannerImageProp()}
              //         imgClassName="object-embed"
              //         addWrapper={false}
              //         addImageAsBg={true}
              //       ></ImageBlock>
              //     </div>
              //     <div
              //       id="banner-inner-id-category"
              //       className="banner-inner-category"
              //     >
              //       <div className="outer-text-container-category">
              //         <div className="text-container-category">
              //           <div className="text-content-category">
              //             <h1 className="banner-main-title-category">
              //               {this.props.title}
              //             </h1>
              //             <div className="banner-desc-category">
              //               <span>
              //                 <SafeHTML>{this.props.description}</SafeHTML>
              //               </span>
              //             </div>
              //           </div>
              //         </div>
              //       </div>
              //     </div>
              //   </div>
              // </div>
              <div>
                <div className="hero-banner-background" style={this.state.isMobile ? { backgroundImage: "url('" + this.props.mobileImage.url + "')", backgroundSize: 'cover', marginTop: '94px', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', minHeight: '336px', paddingTop: '3px' } : { backgroundImage: "url('" + this.props.image.url + "')", backgroundSize: 'cover', marginTop: '7%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                  {/* <div className="Product-cat-intro-banner"> */}
                  {/* {this.state.isMobile &&<ImageBlock
                  height={true}
                  image={this.getBannerImageProp()}
                  imgClassName="product-home-banner category-intro-banner"
                  addWrapper={false}
                  addImageAsBg={true}
                ></ImageBlock>} */}
                  <div className="product-cat-data-outer">
                    <div className="product-cat-data" style={this.state.isMobile ? { paddingTop: '5px' } : undefined}>
                      <h1 className="product-cat-home-banner-text sm-mobile-banner-text" style={this.state.isMobile ? { display: 'flex', justifyContent: 'center', paddingRight: '172px' } : undefined}>
                        <SafeHTML>{this.props?.title}</SafeHTML>
                      </h1>
                      <p className="product-cat-home-desc-text" style={this.state.isMobile ? { paddingRight: '188px' } : undefined}>
                        <SafeHTML>{this.props?.description}</SafeHTML>
                      </p>
                      <div class="product-btns tab-buuton-align" style={this.state.isMobile ? { paddingRight: '40px', paddingTop: '0px' } : { paddingRight: '54px', paddingTop: '0px' }}><a href={this.generateLink("/contact/")}><button class="btn btn-outline-contact buy-now-btn" style={{ fontSize: '16px' }}>Schedule Demo</button></a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </div>
            )}

          {this.props.eyebrow === "whats_in_the_box_section" && (
            <>
              <div>
                <h2 className="product-details-whats-in-the-box" style={{ textAlign: "center", fontWeight: "bold", fontSize: "21px", marginBottom: '0px', }}>
                  What's in the box<span style={{ color: "#7dccfa" }}></span>
                </h2>
                <p className="whats-in-the-box-sub-text">All you need to get accurate color measurement in minutes!</p>
                <div style={{ position: "relative" }} class="tab-content">
                  {this.tabParts.map((item, index) => {
                    if (index === 0) {
                      return (
                        <div
                          id={`tab${index}`}
                          className={`tab-pane ${activeTab === "tab0" ? "active" : ""
                            }`}
                        >
                          <div className="tab-content-wrapper">
                            <div className="product-img-and-bluearrow-container" >

                              <img
                                className="tab-image"
                                src={this.props.image1.url}
                              />
                              <img className="mobileview-whats-box-image" src={ArrowImage} alt="arrow-img" />
                            </div>

                            <p>{this.props.alt1}</p>
                          </div>
                        </div>
                      );
                    }
                    if (index === 1) {
                      return (
                        <div
                          id={`tab${index}`}
                          className={`tab-pane ${activeTab === "tab1" ? "active" : ""
                            }`}
                        >
                          <div className="tab-content-wrapper">
                            <div className="product-img-and-bluearrow-container" >
                              <img src={this.props.image2.url} className="tab-image" />
                              <img className="mobileview-whats-box-image" src={ArrowImage} alt="arrow-img" />
                            </div>

                            <p>{this.props.alt2}</p>
                          </div>
                        </div>
                      );
                    }
                    if (index === 2) {
                      return (
                        <div
                          id={`tab${index}`}
                          className={`tab-pane ${activeTab === "tab2" ? "active" : ""
                            }`}
                        >
                          <div className="tab-content-wrapper">
                            <div className="product-img-and-bluearrow-container" >
                              <img src={this.props.image3.url} className="tab-image" />
                              <img className="mobileview-whats-box-image" src={ArrowImage} alt="arrow-img" />
                            </div>

                            <p>{this.props.alt3}</p>
                          </div>
                        </div>
                      );
                    }
                    if (index === 3) {
                      return (
                        <div
                          id={`tab${index}`}
                          className={`tab-pane ${activeTab === "tab3" ? "active" : ""
                            }`}
                        >
                          <div className="tab-content-wrapper">
                            <div className="product-img-and-bluearrow-container" >
                              <img src={this.props.image4.url} className="tab-image" />
                              <img className="mobileview-whats-box-image" src={ArrowImage} alt="arrow-img" />
                            </div>

                            <p>{this.props.alt4}</p>
                          </div>
                        </div>
                      );
                    }
                    if (index === 4) {
                      return (
                        <div
                          id={`tab${index}`}
                          className={`tab-pane ${activeTab === "tab4" ? "active" : ""
                            }`}
                        >
                          <div className="tab-content-wrapper">
                            <div className="product-img-and-bluearrow-container" >
                              <img src={this.props.image5.url} className="tab-image" />
                              <img className="mobileview-whats-box-image" src={ArrowImage} alt="arrow-img" />
                            </div>

                            <p>{this.props.alt5}</p>
                          </div>
                        </div>
                      );
                    }
                  })}

                  <div className="whats-arrow-img-container">
                    <img
                      className="whats-box-image"
                      src={ArrowImage}
                      alt="arrow-img"
                    />
                  </div>

                  {/* <div> */}
                  <h2 className="whats-in-the-box-text">Product Details</h2>
                  <div
                    className={
                      "specs-navbar-wrap" + (this.state.isMenuOpen ? " open" : "")
                    }
                  >
                    <label
                      className="specs-navbar-label"
                      onClick={() => this.toggleMenu()}
                    >
                      Select
                    </label>


                  </div>
                  <div className={`tabs ${isMenuOpen ? 'show' : ''}`}>
                    {this.tabParts.map((item, index) => {
                      return (
                        <>
                          <button
                            key={index}
                            className={`tab-button ${activeTab === `tab${index}` ? "active" : ""
                              }`}
                            onClick={() => this.openTab(`tab${index}`)}
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                          >
                            {item}
                          </button>
                        </>
                      );
                    })}
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </>
          )}

          {this.props.title !== "Contact Us" &&
            this.props.title !== "Contáctenos" &&
            this.props.eyebrow === "product_detail_youtube_banner" && (
              <section className={this.getClassname()}>
                <div>
                  {this.props.image1 && (
                    <div className="banner-object slider yt-banner">
                      <SimpleSlider
                        bannerData={this.props}
                        sliderData={this.getSliderurls()}
                      ></SimpleSlider>
                    </div>
                  )}
                </div>
              </section>
            )}
        </div>
      </>
    );
  }
}
